// extracted by mini-css-extract-plugin
export default {"wrapper":"ManageClientsPage_wrapper__SRjrt","clientCard":"ManageClientsPage_clientCard__5Wd3G","clientCardTitle":"ManageClientsPage_clientCardTitle__sGMQc"};